export default __webpack_public_path__ + "static/eyes-3d25f180628dc566374729f9529af0d5.png";